<script>
  import Vue from 'vue';
  import '../assets/bootstrap-datepicker.min.js';
  import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min';
  var moment = require('moment');

  export default Vue.component('datepicker', {
    template: '<input placeholder="dd-mm-jjjj" />',
    props: [ 'value' ],
    mounted: function() {
      var self = this;
      this.$el.value = this.value ? moment(this.value, 'DD-MM-YYYY').format('DD-MM-YYYY') : '';
      $(this.$el).datepicker({
        forceParse: false,
        language: "nl",
        startView: 0,
        maxViewMode: 2,
        todayBtn: "linked",
        autoclose: true,
        keyboardNavigation: false,
        todayHighlight: true,
        assumeNearbyYear: true,
        updateViewDate: false
      }).on("changeDate", function(e) {
        self.$emit('update:value', this.value);
      }).on("hide", function(e) {
        self.$emit('update:value', this.value);
      });
    },
    beforeDestroy: function() {
      $(this.$el).datepicker('hide').datepicker('destroy');
    }
  });
</script>

<style lang="scss">
  @import "../_common.scss";
  @import "../styles/datepicker.css";

  .datepicker .prev,
  .datepicker .datepicker-switch,
  .datepicker .next,
  .datepicker .today {
    background-color: dji-color(lichtblauw, 3);
  }

  .datepicker td.today.day {
    background-image: none;
    background-color: dji-color(hemelblauw, 3);
  }
</style>



// WEBPACK FOOTER //
// src/components/datepicker.vue